module.exports = __webpack_public_path__ + "static/wifi-c1c29136f4d197ce440b29abda71e6ee.png";